import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.string.fixed";

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  flex: 1 1 auto;\n  margin: 0;\n  text-align: center;\n  white-space: nowrap;\n  font-size: 16;\n  line-height: 1.2;\n\n  a,\n  button {\n    appearance: none;\n    color: nav-link;\n    display: flex;\n    padding: 0 10;\n    background-color: transparent;\n    border: 0;\n    transition: base;\n    transition-property: color;\n    cursor: pointer;\n\n    &:hover,\n    &:focus {\n      outline: none;\n      color: nav-link-hover;\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  color: text;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  height: 34;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n      mask-image: none;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 34;\n  margin-left: 10;\n  position: relative;\n  mask-image: linear-gradient(\n    to right,\n    transparent,\n    ", " 5%,\n    ", " 95%,\n    transparent\n  );\n  overflow-x: auto;\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: 20;\n  line-height: 0.9;\n  margin: 0;\n  margin-left: 10;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  color: text;\n  height: 34;\n  margin-right: 16;\n\n  &:hover {\n    color: text;\n  }\n\n  > div {\n    flex-shrink: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-flow: row nowrap;\n  position: relative;\n  text-align: left;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: bg;\n  border-bottom: 1;\n  border-color: border;\n  padding: 16 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import staticQueryData from "../../../../public/static/d/1722779552.json";
import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import styled, { Box, css, useColorMode } from '@xstyled/styled-components';
import { th, up } from '@xstyled/system';
import { Grid } from '@smooth-ui/core-sc';
import { DocSearch } from './DocSearch';
import GithubBrands from './icons/GithubBrands';
import SunSolid from './icons/SunSolid';
import MoonSolid from './icons/MoonSolid';
var Container = styled.div(_templateObject());
var Header = styled.div(_templateObject2());
var LogoLink = styled(Link)(_templateObject3());
var LogoText = styled.h2(_templateObject4());
var Nav = styled.nav(_templateObject5(), th.color('text'), th.color('text'), up('sm', css(_templateObject6())));
var NavList = styled.ul(_templateObject7());
var NavListItem = styled.li(_templateObject8());
var modeIcons = {
  light: MoonSolid,
  dark: SunSolid
};

function getInverseMode(mode) {
  return mode === 'light' ? 'dark' : 'light';
}

function ColorModeSwitcher() {
  var _useColorMode = useColorMode(),
      mode = _useColorMode[0],
      setMode = _useColorMode[1];

  var Icon = modeIcons[mode];
  return React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setMode(getInverseMode);
    }
  }, React.createElement(Icon, {
    width: "24",
    height: "24"
  }));
}

export function ProjectHeader() {
  var data = staticQueryData.data;
  return React.createElement(React.Fragment, null, React.createElement(Container, null, React.createElement(Grid, {
    gutter: 20
  }, React.createElement(Header, null, React.createElement(LogoLink, {
    to: "/"
  }, React.createElement(Img, {
    fixed: data.logo.childImageSharp.fixed,
    alt: data.site.siteMetadata.title
  }), React.createElement(LogoText, null, data.site.siteMetadata.title)), React.createElement(Box, {
    ml: "auto"
  }, data.site.siteMetadata.algoliaDocSearch.enabled && React.createElement(DocSearch, data.site.siteMetadata.algoliaDocSearch)), React.createElement(Nav, null, React.createElement(NavList, null, data.site.siteMetadata.nav.map(function (_ref) {
    var title = _ref.title,
        url = _ref.url;
    return React.createElement(NavListItem, {
      key: title
    }, React.createElement(Link, {
      to: url
    }, title));
  }), React.createElement(NavListItem, null, React.createElement("a", {
    href: data.site.siteMetadata.github,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(GithubBrands, {
    width: "24",
    height: "24"
  }))), React.createElement(NavListItem, null, React.createElement(ColorModeSwitcher, null))))))));
}